import * as React from "react";
import { useTransactionUploadV2 } from "@iliotech/data-wire/src/stores";
import { Input } from "@progress/kendo-react-inputs";
import { InputChangeEvent } from "@progress/kendo-react-inputs";
import { observer } from "mobx-react-lite";

const CommissionCell = ({ index }: { index: number }) => {
  const store = useTransactionUploadV2();
  const commission = store.equities.getField(
    "commission",
    index + ""
  ) as number;

  const onChange = (event: InputChangeEvent) => {
    store.equities.updateTableRowByIndex("commission", event.value, index + "");
  };

  return (
    <Input
      name={"commission"}
      type={"number"}
      value={commission}
      onChange={onChange}
    />
  );
};

export default observer(CommissionCell);
